import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { serviceConstants } from 'src/app/constants/service.constants';

@Injectable({
  providedIn: 'root'
})
export class EmailTemplatesService {

  constructor(private readonly http: HttpClient) { } 

  getHeaders(): any {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      withCredentials: true
    };
    return httpOptions;
  }
  
  getanplaceholders(): Observable<any> {
    return this.http.get(serviceConstants.apiURL + 'api/AlertsAndNotifications/GetANPlaceHolders', this.getHeaders());
  }

  getApplicablePrograms(OrgCode:string): Observable<any> {
    return this.http.get(serviceConstants.apiURL + 'api/EmailTemplates/GetApplicablePrograms/' + OrgCode, this.getHeaders());
  }

  SaveEmailTemplate(model:EmailTemplate):Observable<any>{
    return this.http.post(serviceConstants.apiURL + 'api/EmailTemplates/SaveEmailTemplates',model, this.getHeaders());
  }

  GetEmailTemplatesSearchSummary(model:EmailTemplate):Observable<any>{
    return this.http.post(serviceConstants.apiURL + 'api/EmailTemplates/GetEmailTemplatesSearchSummary',model, this.getHeaders());
  }

  getEmailTemplateById(Id:string): Observable<any> {
    return this.http.get(serviceConstants.apiURL + 'api/EmailTemplates/GetEmailTemplateById/' + Id, this.getHeaders());
  }

  DeleteEmailTemplateById(Id:string): Observable<any> {
    return this.http.get(serviceConstants.apiURL + 'api/EmailTemplates/DeleteEmailTemplateById/' + Id, this.getHeaders());
  }
  
}

export interface EmailTemplate {
  EmailTempID?: string;
  ModuleId:string;
  Name?: string;
  RecordState?: number;
  EmailTo: string;
  ToPlaceHolders: string;
  EmailCc: string;
  CcPlaceHolders: string;
  EmailBcc: string;
  EmailSubject: string;
  EmailBody: string;
  OperationType:string;
}
